<template>
    <div class="btn-container">
        <div v-if="showButtonPrevious" class="btn-style">
            <CieloButton :transparent="true" @click="$emit('click-previous')">
                <span v-text="$ml.get(backText)" />
            </CieloButton>
        </div>
        <div v-if="showButtonNext" style="min-width: 195px;" class="btn-style">
            <CieloButton
                :loading="loading"
                :disabled="disableButtonNext"
                :class="success ? 'btn-success' : ''"
                @click="$emit('click-next')"
            >
                <div class="button-content" v-if="isPixOpenFinance">
                    <img src="@/assets/img/payment-types/pix-open-finance.svg" alt="banco" class="button-icon" style="filter: invert(100%) brightness(200%);" />
                    <span v-text="buttonText" />
                </div>
                <span v-else v-text="buttonText" />
            </CieloButton>
        </div>
    </div>
</template>

<script>
const CieloButton = () => import(
	/* webpackChunkName: "cielo-button" */
	'@/components/template/CieloButton'
);

export default {
	props: {
		showButtonPrevious: {
			type: Boolean,
			default: true
		},
		showButtonNext: {
			type: Boolean,
			default: true
		},
		success: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		disableButtonNext: {
			type: Boolean,
			default: true
		},
		isQrcode: {
			type: Boolean,
			default: false
		},
		isPix: {
			type: Boolean,
			default: false
		},
		isPixOpenFinance: {
			type: Boolean,
			default: false
		},
		isAbleToApplyConvenienceFee: {
			type: Boolean,
			default: false
		},
		backText: {
			type: String,
			default: 'back'
		},
		nextTextKey: {
			type: String,
			default: null
		},
	},

	components: {
		CieloButton,
	},

	computed: {
		buttonText() {
			if (this.nextTextKey) return this.$ml.get(this.nextTextKey);
			if (this.isQrcode) return this.$ml.get('finishButtonQrCode');
			if (this.isPix) return this.$ml.get('finishButtonPix');
			if (this.isPixOpenFinance) return this.$ml.get('finishButtonPixOpenFinance');
			if (this.isAbleToApplyConvenienceFee) return this.$ml.get('convenienceFeeFinishPayment');
			return this.$ml.get('completePurchase');
		}
	},
};

</script>

<style lang="scss" scoped>
.btn-container {
	@media screen and (max-width: 1024px) {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 20px;
}

.btn-style {
	@media screen and (max-width: 1024px) {
		flex-direction: column;
		align-items: flex-start;
		width: 100%;

	}


	align-items: flex-start;
	flex: 1
}

.button-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
}
</style>
